import { useContext } from "react";
import { useSelector } from "react-redux";
import { ProjectStatusCreationError } from "@planzone/dto";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  error: ProjectStatusCreationError;
  createProjectStatus(
    request: Boundaries["createProjectStatus"]["request"],
  ): void;
}

function useProjectStatusCreation(): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(
      selector.isProjectStatusCreationRequestPending,
    ),
    isRequestSuccess: useSelector(
      selector.isProjectStatusCreationRequestSuccess,
    ),
    isRequestFailure: useSelector(
      selector.isProjectStatusCreationRequestFailure,
    ),
    error: useSelector(selector.getProjectStatusCreationError),
    createProjectStatus: core.createProjectStatus,
  };
}

export { useProjectStatusCreation };
